var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 37,
    viewBox: "0 0 25 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M14.155 3.126l.8-1.387c.117-.201-.029-.455-.263-.455h-1.601L12.438.153c-.117-.204-.41-.204-.526 0l-.654 1.13h-1.6c-.235 0-.381.255-.264.456l.8 1.387-.8 1.386c-.117.203.03.456.263.456h1.6l.655 1.132c.116.203.409.203.526 0l.653-1.132h1.601c.234 0 .38-.253.263-.456l-.8-1.386z",
    transform: "translate(.487 .728)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F54",
    d: "M.468 35.683c-.258 0-.468-.21-.468-.468V14.82c0-.259.21-.468.468-.468s.468.21.468.468v20.394c0 .258-.21.468-.468.468M22.543 35.683c-.258 0-.468-.21-.468-.468V14.82c0-.259.21-.468.468-.468.259 0 .468.21.468.468v20.394c0 .258-.21.468-.468.468",
    transform: "translate(.487 .728)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 14.744v5.007c0 .78.584 1.477 1.361 1.517.83.044 1.516-.615 1.516-1.435 0 .794.643 1.438 1.438 1.438.794 0 1.438-.644 1.438-1.438 0 .794.644 1.438 1.438 1.438.794 0 1.439-.644 1.439-1.438 0 .794.643 1.438 1.438 1.438.794 0 1.438-.644 1.438-1.438 0 .794.643 1.438 1.438 1.438.794 0 1.438-.644 1.438-1.438 0 .794.644 1.438 1.439 1.438.793 0 1.438-.644 1.438-1.438 0 .794.643 1.438 1.438 1.438.794 0 1.438-.644 1.438-1.438 0 .82.686 1.48 1.515 1.435.778-.04 1.362-.738 1.362-1.517v-5.007c0-.391-.359-.687-.743-.61-1.703.338-6.105 1.111-10.763 1.111-4.66 0-9.06-.773-10.764-1.111-.383-.077-.742.219-.742.61",
    transform: "translate(.487 .728)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedding);
export default __webpack_public_path__ + "static/media/wedding.1126086aad9ccbcdbae3fec4e3cc6beb.svg";
export { ForwardRef as ReactComponent };